import store from "../store";

export default {
    data() {
        return {
        }
    },
    created() {
        let htmlWidth = document.documentElement.clientWidth || document.body.clientWidth
        let htmlDom = document.getElementsByTagName('html')[0]
        htmlDom.style.fontSize = htmlWidth / 10 + 'px';
        this.htmlWidth = htmlWidth;
        window.addEventListener('resize', () => {
            let htmlWidth = document.documentElement.clientWidth || document.body.clientWidth
            let htmlDom = document.getElementsByTagName('html')[0]
            htmlDom.style.fontSize = htmlWidth / 10 + 'px';
            this.htmlWidth = htmlWidth;
        })
    },
    methods: {
        dispatchExtend(url, param) {//正常请求
            if (!url) { console.error('url empty!!!'); return; }
            return new Promise((resolve, reject) => {
                this.$store.dispatch(url, param)
                    .then((res) => {
                        resolve(res);
                    }, (err) => {
                        //公共错误回调
                        reject(err);
                    })
            })
        },
        openParentForm(data) {
            console.log(this.$parent);
        }
    }
}


// WEBPACK FOOTER //
// ./src/mixins/global.js